/* ================================================================
   multi-buy.js  —  assets/multi-buy.js
   ================================================================
   Handles:
   - Buy 1 / Buy 2 option card switching
   - Second item card selection + variant dropdowns
   - Stock awareness (out-of-stock variants disabled)
   - Live price summary display
   - Add both items to cart via Cart API with _multi_buy property
   - Re-syncs prices when the main product variant changes
   ================================================================ */

(function () {
  'use strict';

  function init() {
    var wrapper = document.getElementById('multi-buy-wrapper');
    if (!wrapper) return;

    /* ── State ── */
    var state = {
      qty: 1,
      primaryVariantId:   wrapper.dataset.currentVariantId,
      primaryPrice:       parseInt(wrapper.dataset.currentPrice, 10),
      discount:           parseInt(wrapper.dataset.discount, 10),
      secondVariantId:    null,
      secondPrice:        0,
      secondProductTitle: '',
      secondVariantTitle: ''
    };

    /* ── Element refs ── */
    var els = {
      options:      wrapper.querySelectorAll('.mb-option'),
      secondWrap:   document.getElementById('mb-second-wrap'),
      summaryWrap:  document.getElementById('mb-summary'),
      summaryLines: document.getElementById('mb-summary__lines'),
      discNote:     document.getElementById('mb-discount-note')
    };

    /* ── Money formatter ── */
    function money(cents) {
      var format = wrapper.dataset.moneyFormat || '{{amount}}';
      if (window.Shopify && window.Shopify.formatMoney) {
        return Shopify.formatMoney(cents, format);
      }
      return (cents / 100).toFixed(2);
    }

    /* ── Discounted price ── */
    function discounted(baseCents) {
      return Math.round(baseCents * (1 - state.discount / 100));
    }

    /* ══════════════════════════════════════════════════════════
       BUTTON OVERRIDE
       We find the real ATC button, hide it when qty=2, and
       insert our own button that bypasses Unicorn Cart entirely
       by calling /cart/add.js directly.
    ══════════════════════════════════════════════════════════ */
   var productForm = document.querySelector('[data-type="add-to-cart-form"]');
    var realBtn = null;
    var mbBtn = null;

    if (productForm) {
      realBtn = productForm.querySelector('[name="add"], [type="submit"]');

      if (realBtn) {
        mbBtn = document.createElement('button');
        mbBtn.type = 'button';
        mbBtn.className = realBtn.className + ' mb-atc-btn';
        mbBtn.textContent = realBtn.textContent;
        mbBtn.style.display = 'none';
        mbBtn.style.width = '100%';
        realBtn.parentNode.insertBefore(mbBtn, realBtn.nextSibling);

        mbBtn.addEventListener('click', function () {
          if (!state.secondVariantId) {
            highlightSecondPicker();
            return;
          }
          addBothToCart();
        });
      }
    }

    function syncButtons() {
      if (!realBtn || !mbBtn) return;
      if (state.qty === 2) {
        realBtn.style.display = 'none';
        mbBtn.style.display = '';
      } else {
        realBtn.style.display = '';
        mbBtn.style.display = 'none';
      }
    }

    /* ══════════════════════════════════════════════════════════
       PACK SIZE CARDS
    ══════════════════════════════════════════════════════════ */
    els.options.forEach(function (label) {
      label.addEventListener('click', handleQtyChange);
      label.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleQtyChange.call(label, e);
        }
      });
    });

    function handleQtyChange() {
      var qty = parseInt(this.dataset.qty, 10);
      state.qty = qty;

      els.options.forEach(function (l) {
        l.classList.toggle('mb-option--active', parseInt(l.dataset.qty, 10) === qty);
        l.setAttribute('aria-checked', String(parseInt(l.dataset.qty, 10) === qty));
      });

      if (qty === 2) {
        showEl(els.secondWrap);
        if (state.secondVariantId) {
          updateSummary();
          showEl(els.summaryWrap);
          showEl(els.discNote);
        }
      } else {
        hideEl(els.secondWrap);
        hideEl(els.summaryWrap);
        hideEl(els.discNote);
      }

      syncButtons();
    }

    /* ══════════════════════════════════════════════════════════
       SIBLING CARDS
    ══════════════════════════════════════════════════════════ */
    var cards = wrapper.querySelectorAll('.mb-card:not(.mb-card--oos)');

    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (e.target.classList.contains('mb-card__select')) return;
        selectCard(card);
      });

      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectCard(card);
        }
      });

      var select = card.querySelector('.mb-card__select');
      if (select) {
        select.addEventListener('change', function (e) {
          e.stopPropagation();
          var opt = select.options[select.selectedIndex];
          if (opt.dataset.available === 'false') return;
          card.dataset.variantId    = opt.value;
          card.dataset.variantPrice = opt.dataset.price;
          if (card.classList.contains('mb-card--selected')) {
            selectCard(card);
          }
        });
      }
    });

    function selectCard(card) {
      wrapper.querySelectorAll('.mb-card').forEach(function (c) {
        c.classList.remove('mb-card--selected');
        c.setAttribute('aria-pressed', 'false');
      });

      card.classList.add('mb-card--selected');
      card.setAttribute('aria-pressed', 'true');

      state.secondVariantId    = card.dataset.variantId;
      state.secondPrice        = parseInt(card.dataset.variantPrice, 10);
      state.secondProductTitle = card.dataset.productTitle || card.querySelector('.mb-card__name').textContent.trim();

      var sel = card.querySelector('.mb-card__select');
      if (sel) {
        state.secondVariantTitle = sel.options[sel.selectedIndex].text.replace(' \u2013 Out of stock', '');
      } else {
        var vLabel = card.querySelector('.mb-card__variant-label');
        state.secondVariantTitle = vLabel ? vLabel.textContent.trim() : '';
      }

      updateSummary();
      showEl(els.summaryWrap);
      showEl(els.discNote);
    }

    /* ══════════════════════════════════════════════════════════
       PRICE SUMMARY
    ══════════════════════════════════════════════════════════ */
    function updateSummary() {
      var p1    = state.primaryPrice;
      var p2    = state.secondPrice;
      var disc1 = discounted(p1);
      var disc2 = discounted(p2);
      var saving = (p1 + p2) - (disc1 + disc2);

      var html =
        '<div>Item 1: <s>' + money(p1) + '</s> &rarr; <strong>' + money(disc1) + '</strong></div>' +
        '<div>Item 2 (' + escHtml(state.secondProductTitle) +
          (state.secondVariantTitle ? ' \u2014 ' + escHtml(state.secondVariantTitle) : '') +
          '): <s>' + money(p2) + '</s> &rarr; <strong>' + money(disc2) + '</strong></div>' +
        '<div class="mb-summary__total">Total: ' + money(disc1 + disc2) + '</div>' +
        '<div class="mb-summary__saving">You save: ' + money(saving) + ' (' + state.discount + '% off)</div>';

      els.summaryLines.innerHTML = html;
    }

    /* ══════════════════════════════════════════════════════════
       SYNC WITH MAIN VARIANT SELECTOR
    ══════════════════════════════════════════════════════════ */
    document.addEventListener('variant:changed', onVariantChange);
    document.addEventListener('variantChange',   onVariantChange);

    document.querySelectorAll('[name="id"]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        fetchVariantPrice(wrapper.dataset.productHandle, sel.value);
      });
    });

    function onVariantChange(e) {
      var v = e.detail && (e.detail.variant || e.detail.currentVariant);
      if (!v) return;
      applyNewPrimaryVariant(v.id, v.price);
    }

    function fetchVariantPrice(handle, variantId) {
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var v = data.variants.find(function (x) { return String(x.id) === String(variantId); });
          if (v) applyNewPrimaryVariant(v.id, v.price);
        })
        .catch(function () {});
    }

    function applyNewPrimaryVariant(id, price) {
      state.primaryVariantId = String(id);
      state.primaryPrice     = price;

      var singleEl = wrapper.querySelector('.js-mb-single-price');
      var discEl   = wrapper.querySelector('.js-mb-disc-price');
      var fullEl   = wrapper.querySelector('.js-mb-total-full');
      var discTot  = wrapper.querySelector('.js-mb-total-disc');

      if (singleEl) singleEl.textContent = money(price);
      if (discEl)   discEl.textContent   = money(discounted(price));
      if (fullEl)   fullEl.textContent   = money(price * 2);
      if (discTot)  discTot.textContent  = money(discounted(price) * 2);

      if (state.qty === 2 && state.secondVariantId) updateSummary();
    }

    /* ══════════════════════════════════════════════════════════
       ADD BOTH TO CART
    ══════════════════════════════════════════════════════════ */
    function highlightSecondPicker() {
      var grid = document.getElementById('mb-sibling-grid');
      if (!grid) return;
      grid.style.outline = '2px solid red';
      grid.style.borderRadius = '8px';
      setTimeout(function () { grid.style.outline = ''; }, 2000);
      els.secondWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function addBothToCart() {
      if (mbBtn) { mbBtn.disabled = true; mbBtn.textContent = 'Adding\u2026'; }

      var items = [
        {
          id:       parseInt(state.primaryVariantId, 10),
          quantity: 1,
          properties: { _multi_buy: 'true', _multi_buy_pair: String(state.secondVariantId) }
        },
        {
          id:       parseInt(state.secondVariantId, 10),
          quantity: 1,
          properties: { _multi_buy: 'true', _multi_buy_pair: String(state.primaryVariantId) }
        }
      ];

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body:    JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Cart add failed: ' + r.status);
          return r.json();
        })
        .then(function () {
          if (mbBtn) { mbBtn.disabled = false; mbBtn.textContent = realBtn ? realBtn.textContent : 'Add to cart'; }

          /* Fire events to update cart UI */
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('unicorn:refresh', { bubbles: true }));

          /* Try to open Unicorn cart drawer by clicking cart icon */
          var cartIcon = document.querySelector('.cart-icon, .header__icon--cart, [data-cart-icon], #cart-icon-bubble, .icon-cart, [data-unicorn-cart-trigger]');
          if (cartIcon) {
            cartIcon.click();
          } else {
            window.location.href = '/checkout';
          }
        })
        .catch(function (err) {
          console.error('[MultiBuy] Add to cart error:', err);
          alert('Sorry, something went wrong adding items to your cart. Please try again.');
          if (mbBtn) { mbBtn.disabled = false; mbBtn.textContent = realBtn ? realBtn.textContent : 'Add to cart'; }
        });
    }

    /* ══════════════════════════════════════════════════════════
       HELPERS
    ══════════════════════════════════════════════════════════ */
    function showEl(el) { if (el) el.removeAttribute('hidden'); }
    function hideEl(el) { if (el) el.setAttribute('hidden', ''); }
    function escHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }
  }

  /* ── Boot ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();